var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { CONFIG } from "../../../config/app.config";
import * as S from "../FormInputBase/FormInputBase.styles";
import Spacer, { ESpacerWeight } from "../Spacer";
// A reCAPTCHA token is accepted once. When a submit fails (a mistyped password, say) the form is
// sent again, so the widget has to issue a new token or the retry is refused as an invalid
// captcha: resetCaptchas() clears every mounted widget and the value it gave its form.
var resetListeners = new Set();
export var resetCaptchas = function () {
    resetListeners.forEach(function (reset) { return reset(); });
};
var FormInputCaptcha = /** @class */ (function (_super) {
    __extends(FormInputCaptcha, _super);
    function FormInputCaptcha() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.recaptchaRef = React.createRef();
        _this.reset = function () {
            var _a;
            (_a = _this.recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.reset();
            _this.props.onChangeValue(undefined);
        };
        return _this;
    }
    // Lifecycle
    FormInputCaptcha.prototype.componentDidMount = function () {
        resetListeners.add(this.reset);
    };
    FormInputCaptcha.prototype.componentWillUnmount = function () {
        resetListeners.delete(this.reset);
    };
    // Render
    FormInputCaptcha.prototype.render = function () {
        var _a = this.props, onChangeValue = _a.onChangeValue, error = _a.error;
        return (_jsxs(_Fragment, { children: [_jsx(Spacer, { weight: ESpacerWeight.W12 }), CONFIG.CAPTCHA_KEY && (_jsx(ReCAPTCHA, { ref: this.recaptchaRef, sitekey: CONFIG.CAPTCHA_KEY, onChange: function (value) {
                        onChangeValue(value || undefined);
                    } })), error && _jsx(S.ErrorText, { children: error })] }));
    };
    return FormInputCaptcha;
}(React.PureComponent));
// eslint-disable-next-line import/no-default-export
export default FormInputCaptcha;
